noop = ->

module.exports = {noop}

module.exports.__esModule = true
module.exports.default = noop
